const puSyncHeaderCartButton = (itemCount) => {
  const count = Number(itemCount) || 0;
  const isEmpty = count === 0;
  const header = document.querySelector(".header");
  const cartIcon = document.getElementById("cart-icon-bubble");

  header?.classList.toggle("header--empty-cart-quick-buy", isEmpty);

  if (!cartIcon) return;

  cartIcon.classList.toggle("header__icon--quick-buy", isEmpty);

  let quickText = cartIcon.querySelector(".header__quick-buy-text");
  const countBubble = cartIcon.querySelector(".cart-count-bubble");

  if (isEmpty) {
    if (!quickText) {
      quickText = document.createElement("span");
      quickText.className = "header__quick-buy-text";
      quickText.textContent = "Quick Buy";
      const hiddenLabel = cartIcon.querySelector(".visually-hidden");
      cartIcon.insertBefore(quickText, hiddenLabel || cartIcon.firstChild);
    }

    countBubble?.remove();
    return;
  }

  quickText?.remove();

  if (countBubble) {
    const visibleCount = countBubble.querySelector("[aria-hidden='true']");
    const hiddenCount = countBubble.querySelector(".visually-hidden");

    if (visibleCount) visibleCount.textContent = count;
    if (hiddenCount) hiddenCount.textContent = `${count} items`;

    return;
  }

  const bubble = document.createElement("div");
  bubble.className = "cart-count-bubble";
  bubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
  cartIcon.appendChild(bubble);
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);

      // handling shopify backend bottlenecking errors.
      try {
        let userInfo = document.getElementById("invisible-data").innerText;
        if (userInfo) {
        } else {
          console.info("User is not logged in");
        }
        const body = JSON.stringify({ note: userInfo });
        const emptyBody = JSON.stringify({ note: "" });
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ emptyBody },
        }).then((response) => {
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body },
          });
        });
      } catch (err) {
        console.info("User is not logged in");
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        // console.log("subscriber events", event);
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // console.log("value", document.getElementById('invisible-data').innerText);

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          if (section.id === "cart-icon-bubble") {
            const sourceCartIcon = new DOMParser()
              .parseFromString(parsedState.sections[section.section], "text/html")
              .getElementById("cart-icon-bubble");
            const currentCartIcon = document.getElementById("cart-icon-bubble");

            if (sourceCartIcon && currentCartIcon) {
              currentCartIcon.replaceWith(sourceCartIcon);
            }

            return;
          }

          const sectionHtml = parsedState.sections[section.section];
          const currentSection = document.getElementById(section.id);
          if (!sectionHtml || !currentSection) return;

          const sourceSection = new DOMParser()
            .parseFromString(sectionHtml, "text/html")
            .querySelector(section.selector);
          if (!sourceSection) return;

          const elementToReplace =
            currentSection.querySelector(section.selector) || currentSection;
          elementToReplace.innerHTML = sourceSection.innerHTML;
        });
        puSyncHeaderCartButton(parsedState.item_count);
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          parsedState.item_count === 0 &&
          parseInt(quantity) === 0
        ) {
          message = "";
        } else if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          customElements;
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });

        // const customerInfo = document.getElementById('invisible-data');
        // if (customerInfo != null){
        //   const noteBody = JSON.stringify({ note: customerInfo?.innerText });
        //   console.log("body", noteBody);
        //   fetch(`${routes.cart_update_url}`, {
        //     ...fetchConfig(),
        //     ...{ noteBody },
        //   });
        // }
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

document.addEventListener("change", (event) => {
  const select = event.target.closest("[data-pu-empty-variant]");
  if (!select) return;

  const card = select.closest("[data-pu-empty-card]");
  if (!card) return;

  const selectedOption = select.options[select.selectedIndex];
  const priceTarget = card.querySelector("[data-pu-empty-price]");
  if (!selectedOption || !priceTarget) return;

  const price = selectedOption.dataset.price || "";
  const compare = selectedOption.dataset.compare || "";
  const compareMarkup =
    compare && compare !== price
      ? `<s class="pu-empty-cart-card__price-compare">${compare}</s>`
      : "";

  priceTarget.innerHTML = `<span class="pu-empty-cart-card__price-current">${price}</span>${compareMarkup}`;
});

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-pu-empty-add]");
  if (!button) return;

  const card = button.closest("[data-pu-empty-card]");
  const select = card?.querySelector("[data-pu-empty-variant]");
  const variantId = select?.value;
  const drawer = document.querySelector("cart-drawer");

  if (!variantId || button.disabled) return;

  button.disabled = true;
  button.textContent = "ADDING";
  card?.querySelector(".pu-empty-cart__error")?.remove();
  drawer?.classList.add("is-updating");

  const config =
    typeof fetchConfig === "function"
      ? fetchConfig()
      : {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };

  fetch(`${routes.cart_add_url}.js`, {
    ...config,
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1,
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: window.location.pathname,
    }),
  })
    .then((response) => {
      if (!response.ok) return response.json().then((error) => Promise.reject(error));
      return response.json();
    })
    .then((state) => {
      const drawerMarkup = state.sections?.["cart-drawer"];
      const cartIconMarkup = state.sections?.["cart-icon-bubble"];

      if (!drawerMarkup) return fetch(`${routes.cart_url}?section_id=cart-drawer`).then((response) => response.text());

      if (cartIconMarkup) {
        const cartIconHtml = new DOMParser().parseFromString(cartIconMarkup, "text/html");
        const sourceCartIcon = cartIconHtml.getElementById("cart-icon-bubble");
        const currentCartIcon = document.getElementById("cart-icon-bubble");

        if (sourceCartIcon && currentCartIcon) {
          currentCartIcon.replaceWith(sourceCartIcon);
        }
      }

      return drawerMarkup;
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const sourceDrawer = html.querySelector("cart-drawer");
      const currentDrawer = document.querySelector("cart-drawer");

      if (sourceDrawer && currentDrawer) {
        sourceDrawer.classList.add("animate", "active");
        sourceDrawer.classList.remove("is-empty", "is-updating");
        currentDrawer.replaceWith(sourceDrawer);
      }

      return fetch(`${routes.cart_url}.js`);
    })
    .then((response) => response.json())
    .then((cartData) => {
      puSyncHeaderCartButton(cartData.item_count);

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "pu-empty-cart",
        cartData,
        variantId,
      });
    })
    .catch((error) => {
      drawer?.classList.remove("is-updating");
      button.disabled = false;
      button.textContent = "ADD TO CART";

      const message = error?.description || error?.message || window.cartStrings?.error || "Could not add this item.";
      const errorNode = document.createElement("p");
      errorNode.className = "pu-empty-cart__error";
      errorNode.textContent = message;
      card?.appendChild(errorNode);
    });
});

(() => {
  if (window.puCartRecoScrollBound) return;
  window.puCartRecoScrollBound = true;

  const recoProductsSelector =
    ".cart-drawer .essential-upsell-cross-sell-block [data-essential-upsell-element='products']";
  const recoProductSelector =
    ".cart-drawer .essential-upsell-cross-sell-block [data-essential-upsell-element='product'], .cart-drawer .pu-empty-cart-card";
  const recoInteractiveSelector =
    "a, button, input, select, textarea, [role='button'], [data-essential-upsell-element='variant-select'], [data-essential-upsell-element='button-container'], [data-essential-upsell-element='add-to-cart-button']";
  let recoPointer = null;
  let recoSuppressClickUntil = 0;

  document.addEventListener(
    "wheel",
    (event) => {
      const row = event.target.closest(recoProductsSelector);
      if (!row || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      row.scrollLeft += event.deltaX;
      event.preventDefault();
    },
    { passive: false },
  );

  document.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "touch" || event.button !== 0) return;

    const row = event.target.closest(recoProductsSelector);
    const scroller = row?.closest("cart-drawer-items");
    const interactive = event.target.closest(
      "button, input, select, textarea, [role='button'], [data-essential-upsell-element='variant-select']",
    );

    if (!row || !scroller || interactive) return;

    recoPointer = {
      row,
      scroller,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      lastX: event.clientX,
      lastY: event.clientY,
      direction: null,
      dragged: false,
    };

    row.classList.add("pu-reco-row--dragging");
    row.setPointerCapture?.(event.pointerId);
  });

  document.addEventListener("pointermove", (event) => {
    if (!recoPointer || event.pointerId !== recoPointer.pointerId) return;

    const diffX = Math.abs(event.clientX - recoPointer.startX);
    const diffY = Math.abs(event.clientY - recoPointer.startY);

    if (!recoPointer.direction && Math.max(diffX, diffY) > 6) {
      recoPointer.direction = diffX >= diffY ? "horizontal" : "vertical";
      recoPointer.dragged = true;
    }

    if (recoPointer.direction === "horizontal") {
      recoPointer.row.scrollLeft += recoPointer.lastX - event.clientX;
    } else if (recoPointer.direction === "vertical") {
      recoPointer.scroller.scrollTop += recoPointer.lastY - event.clientY;
    } else {
      return;
    }

    recoPointer.lastX = event.clientX;
    recoPointer.lastY = event.clientY;
    event.preventDefault();
  });

  ["pointerup", "pointercancel"].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (!recoPointer || event.pointerId !== recoPointer.pointerId) return;

      recoPointer.row.classList.remove("pu-reco-row--dragging");
      recoPointer.row.releasePointerCapture?.(event.pointerId);

      if (recoPointer.dragged) {
        recoSuppressClickUntil = Date.now() + 150;
      }

      recoPointer = null;
    });
  });

  document.addEventListener(
    "click",
    (event) => {
      if (Date.now() > recoSuppressClickUntil || !event.target.closest(recoProductsSelector)) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true,
  );

  document.addEventListener("click", (event) => {
    const productCard = event.target.closest(recoProductSelector);
    if (!productCard || event.target.closest(recoInteractiveSelector)) return;

    const productLink = productCard.querySelector("a[href*='/products/'], a[href]");
    if (!productLink) return;

    event.preventDefault();
    window.location.href = productLink.href;
  });
})();
